import { render } from "./AddCost.vue?vue&type=template&id=5ae45e5b"
import script from "./AddCost.vue?vue&type=script&lang=js"
export * from "./AddCost.vue?vue&type=script&lang=js"
script.render = render

export default script